var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48822 1.00879C9.78914 0.774739 10.2105 0.774739 10.5115 1.00879L18.0115 6.84213C18.2144 7.00001 18.3332 7.24276 18.3332 7.49992V16.6666C18.3332 17.3296 18.0698 17.9655 17.6009 18.4344C17.1321 18.9032 16.4962 19.1666 15.8332 19.1666H4.1665C3.50346 19.1666 2.86758 18.9032 2.39874 18.4344C1.9299 17.9655 1.6665 17.3296 1.6665 16.6666V7.49992C1.6665 7.24276 1.78523 7.00001 1.98822 6.84213L9.48822 1.00879ZM3.33317 7.90749V16.6666C3.33317 16.8876 3.42097 17.0996 3.57725 17.2558C3.73353 17.4121 3.94549 17.4999 4.1665 17.4999H15.8332C16.0542 17.4999 16.2661 17.4121 16.4224 17.2558C16.5787 17.0996 16.6665 16.8876 16.6665 16.6666V7.90749L9.99984 2.7223L3.33317 7.90749Z",
    fill: "#25282B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 10.0001C6.6665 9.53984 7.0396 9.16675 7.49984 9.16675H12.4998C12.9601 9.16675 13.3332 9.53984 13.3332 10.0001V18.3334C13.3332 18.7937 12.9601 19.1667 12.4998 19.1667C12.0396 19.1667 11.6665 18.7937 11.6665 18.3334V10.8334H8.33317V18.3334C8.33317 18.7937 7.96007 19.1667 7.49984 19.1667C7.0396 19.1667 6.6665 18.7937 6.6665 18.3334V10.0001Z",
    fill: "#25282B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d1e77e53089b4966a0f58c4eba3266ed.svg";
export { ForwardRef as ReactComponent };